import classNames from 'classnames'
import React from 'react'
import { Illustration, IllustrationSize } from '../illustration'
import type { ShapeComponentType } from '../shape'
import { ShapeType } from '../shape'
import styles from './IllustrationBlob.module.scss'
import type { IllustrationBlobProps, IllustrationBlobSizeType } from './types'
import { IllustrationBlobSize, IllustrationBlobType } from './types'

const mapperSizes: Map<IllustrationBlobSizeType, IllustrationSize> = new Map([
  [IllustrationBlobSize.xxlarge, IllustrationSize.xxlarge],
  [IllustrationBlobSize.xlarge, IllustrationSize.xlarge],
  [IllustrationBlobSize.large, IllustrationSize.large],
  [IllustrationBlobSize.medium, IllustrationSize.medium],
  [IllustrationBlobSize.small, IllustrationSize.small],
])

const validateShape = (shape: ShapeComponentType, type: keyof typeof IllustrationBlobType) => {
  const Shape = shape
  let ShapeComponent = null
  if (shape && React.isValidElement(<Shape />)) {
    ShapeComponent = <Shape />
    const componentType = ShapeComponent.type.name
    if (
      (type === IllustrationBlobType.floating && componentType.includes(ShapeType.Blob)) ||
      (type !== IllustrationBlobType.floating && componentType.includes(ShapeType.Shadow))
    ) {
      ShapeComponent = null
    }
  }
  return ShapeComponent
}

const IllustrationBlob: React.FC<IllustrationBlobProps> = ({
  className,
  size = IllustrationBlobSize.medium,
  type = IllustrationBlobType.neutral,
  shape,
  src,
  alt,
  ...props
}) => {
  const ShapeComponent = validateShape(shape, type)
  const illustrationSize = mapperSizes.get(size) || IllustrationSize.medium
  return (
    <div
      className={classNames(styles['pintxo-illustration-blob'], className)}
      data-size={size}
      data-type={type}
    >
      <div className={styles['pintxo-illustration-blob__shape']}>
        {ShapeComponent && ShapeComponent}
      </div>
      <div className={styles['pintxo-illustration-blob__illustration']}>
        <Illustration size={illustrationSize} src={src} alt={alt} {...props} />
      </div>
    </div>
  )
}

export default IllustrationBlob
